<template>
  <div id="projects">
    <div>
      <vs-alert
        v-for="notice in notices"
        :key="notice.NoticeID"
        :color="notice.BgColor"
        :title="notice.NoticeSubject"
        :active.sync="notice.IsActive"
        closable
        icon-pack="feather"
        close-icon="icon-x"
        class="mb-5"
      >
        <span v-html="notice.NoticeDesc"></span>
      </vs-alert>

      <div class="relative mb-8 step-filter-3 mb-base">
        <!-- SEARCH INPUT -->
        <vs-input
          class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
          placeholder="Hangi siteyi aramıştınız?"
          v-model="searchQuery"
          size="large"
        />

        <!-- SEARCH ICON -->
        <div
          slot="submit-icon"
          class="absolute top-0 right-0 py-4 px-6"
          v-show="!searchQuery"
        >
          <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
        </div>

        <!-- CLEAR INPUT ICON -->
        <div
          slot="reset-icon"
          class="absolute top-0 right-0 py-4 px-6"
          @click="searchQuery = ''"
          v-show="searchQuery"
        >
          <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" />
        </div>
      </div>
    </div>
    <div class="items-grid-view vx-row match-height">
      <Tilt
        :options="tiltOptions"
        v-for="item in projectList"
        :key="item.ProjectID"
        class="vx-col md:w-1/3 lg:w-1/4 xl:w-1/5 xxl sm:w-1/2 w-full"
      >
        <transition name="zoom-out" mode="out-in" appear>
          <vx-card
            class="grid-view-item mb-base overflow-hidden"
            style="border-radius:2.5rem"
            :id="'openBtn-' + item.ProjectID"
          >
            <template slot="no-body">
              <div>
                <div
                  class="item-img-container bg-white h-56 flex items-center justify-center mb-4 mt-6 cursor-pointer"
                  @click="openLink(item)"
                >
                  <img
                    :src="item.ProjectImage ? item.ProjectImage : graphic"
                    :alt="item.ProjectName"
                    class="grid-view-img px-4"
                  />
                </div>
                <div class="item-details px-4">
                  <div class="my-4 text-center">
                    <h6
                      class="truncate font-semibold mb-5 hover:text-primary cursor-pointer"
                      @click="openLink(item)"
                    >
                      {{ item.ProjectName }}
                    </h6>
                  </div>
                </div>

                <slot name="action-buttons">
                  <div class="flex flex-wrap flex-col-reverse">
                    <vx-auto-suggest
                      v-if="isStaff"
                      :ref="'navbarSearch_' + item.ProjectID"
                      :id="'navbarSearch_' + item.ProjectID"
                      :data="userList"
                      search_key="title"
                      background-overlay
                      :item="item"
                      inputClassses="vs-input-no-border vs-input-no-shdow-focus"
                      placeholder="Gözünden Gör"
                      @input="hnd_search_query_update"
                      @selected="loginByUser"
                    >
                      <template v-slot:group="{ group_name }">
                        <p class="font-semibold text-primary">
                          {{ groups[group_name] }}
                        </p>
                      </template>

                      <!-- No Items Slot -->
                      <template v-slot:noResult="{ group_name }">
                        <div class="flex items-center">
                          <feather-icon
                            icon="InfoIcon"
                            svgClasses="h-5 w-5"
                            class="mr-4"
                          />
                          <span>Kişi bulunamadı.</span>
                        </div>
                      </template>
                    </vx-auto-suggest>
                  </div>
                </slot>
              </div>
            </template>
          </vx-card>
        </transition>
      </Tilt>
    </div>

    <vs-popup
      id="popup_sss"
      :title="sssPopup.title"
      :active.sync="sssPopupSync"
    >
      <div v-html="sssPopup.desc"></div>
    </vs-popup>

    <vs-popup
      id="popup_iframe"
      :title="popupIframe.title"
      class="vs-iframe"
      :active.sync="popupIframeSync"
    >
      <div v-html="popupIframe.desc"></div>
    </vs-popup>
  </div>
</template>

<script>
import Vue from "vue";
import AuthApi from "@/api/auth";
import StaffApi from "@/api/staff";

import DashApi from "@/api/dash";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import Tilt from "vanilla-tilt-vue";

export default {
  components: {
    VxAutoSuggest,
    Tilt,
  },
  data() {
    return {
      tiltOptions: {
        reverse: false, // reverse the tilt direction
        max: 0, // max tilt rotation (degrees)
        startX: 0, // the starting tilt on the X axis, in degrees.
        startY: 0, // the starting tilt on the Y axis, in degrees.
        perspective: 1000, // Transform perspective, the lower the more extreme the tilt gets.
        scale: 1, // 2 = 200%, 1.5 = 150%, etc..
        speed: 500, // Speed of the enter/exit transition
        transition: true, // Set a transition on enter/exit.
        axis: null, // What axis should be disabled. Can be X or Y.
        reset: true, // If the tilt effect has to be reset on exit.
        easing: "cubic-bezier(.03,.98,.52,.99)", // Easing on enter/exit.
        glare: false, // if it should have a "glare" effect
        "max-glare": 1, // the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
        "glare-prerender": false, // false = VanillaTilt creates the glare elements for you, otherwise
        // you need to add .js-tilt-glare>.js-tilt-glare-inner by yourself
        "mouse-event-element": null, // css-selector or link to HTML-element what will be listen mouse events
        // you need to add .js-tilt-glare>.js-tilt-glare-inner by yourself
        gyroscope: false, // Boolean to enable/disable device orientation detection,
        gyroscopeMinAngleX: -45, // This is the bottom limit of the device angle on X axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the left border of the element;
        gyroscopeMaxAngleX: 45, // This is the top limit of the device angle on X axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the right border of the element;
        gyroscopeMinAngleY: -45, // This is the bottom limit of the device angle on Y axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the top border of the element;
        gyroscopeMaxAngleY: 45, // This is the top limit of the device angle on Y axis, meaning that a device rotated at this angle would tilt the element as if the mouse was on the bottom border of the element;
      },
      groups: ["İdari", "Akademik", "Öğrenci", "Tümer", "Diğer"],
      submitBusy: [],
      userList: {},
      notices: [],
      sssPopupSync: false,
      sssPopup: {
        title: "",
        desc: "",
      },
      popupIframeSync: false,
      popupIframe: {
        title: "",
        desc: "",
      },
      graphic: "/blank_logo.png",
    };
  },
  computed: {
    isStaff() {
      return this.$auth.hasUserRole("Staff.");
    },
    searchQuery: {
      get() {
        return this.$store.getters["project/searchQuery"];
      },
      set(val) {
        this.$store.dispatch("project/setSearchQuery", val);
      },
    },
    projectList() {
      return this.$store.getters["project/projectList"];
    },
  },
  methods: {
    loginByUser(item) {
      var id = item[Object.keys(item)[0]].Id;
      if (id > 0) {
        this.openLink(item.item, id);
      }
    },
    hnd_search_query_update(query) {
      //this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
    showIframePopup(item) {
      this.popupIframeSync = true;
      this.popupIframe.title = item.ProjectDesc;
      this.popupIframe.desc = item.ProjectHtml;
    },
    showSSS(item) {
      if (item.ProjectHtml) {
        this.sssPopupSync = true;
        this.sssPopup.title = item.ProjectName;
        this.sssPopup.desc = item.ProjectHtml;
      } else {
        this.$vs.notify({
          time: 1500,
          title: "Uyarı",
          text: "Henüz açıklama girilmemiş.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    },
    existsFavoriteById(id) {
      return this.$store.getters["project/existsFavProjectId"](id);
    },
    toggleFavorites(item) {
      var existsFav = this.$store.getters["project/existsFavProjectId"](
        item.ProjectID
      );
      if (existsFav) this.$store.dispatch("project/removeFavoriteSite", item);
      else this.$store.dispatch("project/addFavoriteSite", item);
    },
    async openLink(item, userId = null) {
      if (item.ProjectReturnUrl) {
        if (this.submitBusy[item.ProjectID]) return;
        this.submitBusy[item.ProjectID] = true;

        this.$vs.loading({
          color: "#000",
          container: "#openBtn-" + item.ProjectID,
          scale: 0.45,
        });

        var renewData = {
          Referer: item.ProjectReturnUrl,
          UserID: userId,
        };

        try {
          var response = await AuthApi.renew(renewData, this);

          if (
            !response.data.error &&
            !response.data.errors &&
            response.data.GatewayUrl
          ) {
            if (response.data.ModuleType == 0) {
              var gateway = await AuthApi.gateway(
                response.data.GatewayUrl,
                this
              );

              if (!gateway.data.error && !gateway.data.errors) {
                window.open(response.data.Referer, "_blank") ||
                  window.location.assign(response.data.Referer);
              }
            } else if (response.data.ModuleType == 1) {
              window.open(response.data.GatewayUrl, "_blank") ||
                window.location.assign(response.data.GatewayUrl);
            } else if (response.data.ModuleType == 2) {
              this.showIframePopup(response.data);
            } else if (response.data.ModuleType == 3) {
              window.open(response.data.ProjectHtml, "_blank") ||
                window.location.assign(response.data.ProjectHtml);
            } else if (response.data.ModuleType == 4) {
              // Cross-domain SPA (CMS admin.fatihsultan.edu.tr): gateway token
              // URL'sini tam sayfa / yeni sekmede ac. XHR + ucuncu-taraf cookie
              // (ModuleType 0) farkli kok domainde calismaz; first-party sart.
              // Hedef: {host}/api/gateway/login?token=...
              window.open(response.data.GatewayUrl, "_blank") ||
                window.location.assign(response.data.GatewayUrl);
            }
          }
        } catch {}

        setTimeout(() => {
          this.$vs.loading.close(
            "#openBtn-" + item.ProjectID + " .con-vs-loading"
          );
        }, 100);

        this.submitBusy[item.ProjectID] = false;
      } else {
        if (item.ModuleType == 2) this.showIframePopup(item);
        else if (item.ModuleType == 3) {
          window.open(item.ProjectHtml, "_blank") ||
            window.location.assign(item.ProjectHtml);
        } else {
          window.open("https://" + item.ProjectBaseUrl, "_blank") ||
            window.location.assign("https://" + item.ProjectBaseUrl);
        }
      }
    },
    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        scale: 0.45,
      });
      let response = await DashApi.getProjects(this);

      if (response && !response.data.error) {
        this.$store.dispatch("project/setProjectList", response.data);
      } else {
        this.$auth.logOut();
        return;
      }

      let noticeResponse = await DashApi.getNotices(this);
      if (noticeResponse && !noticeResponse.data.error) {
        this.notices = noticeResponse.data;
      }

      if (this.isStaff) {
        let userResponse = await StaffApi.getUsers(this);
        if (userResponse && !userResponse.data.error) {
          this.userList = Object.assign({}, userResponse.data);
        }
      }

      setTimeout(() => {
        this.$vs.loading.close();
        window.scrollTo(0, 0);
      }, 100);
    },
  },
  created() {
    var is_safari =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (is_safari) {
      this.tiltOptions.max = 0;
    } else {
      if (window.innerWidth <= 577) {
        this.tiltOptions.max = 0;
      } else this.tiltOptions.max = 20;
    }
  },
  mounted() {
    this.fetchLoadData();
  },
};
</script>

<style lang="scss">
.bg-custom-grey {
  background-color: #969594;
}
.bg-custom-sss {
  background-color: firebrick;
}
#projects {
  .vx-card__title {
    h4 {
      font-size: 14px;
      cursor: pointer;
      color: white;
      background: #165e9e;
      padding: 10px;
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      text-align: center;
    }
  }
}
.h-56 {
  height: 10rem !important;
}
</style>
<style lang="scss">
.dropdown-login {
  width: 348px;
}
</style>
<style lang="scss" scoped>
.grid-view-item {
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}

@media (min-width: 1501px) {
  .xxl {
    width: 16.66667% !important;
  }
}
</style>

<style>
.vs-iframe > .vs-popup {
  width: 100% !important;
}
</style>
